module.exports = __webpack_public_path__ + "ff4f1008ae552c3fb18834568725fe59.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/jane.jpg
// module id = /KvD
// module chunks = 13